/**
 * New Arrivals - Latest products carousel
 * Initializes Splide carousel for new arrivals section
 */
(function ($) {
    function init() {
        $('.new-arrivals .splide').each(function (i, e) {
            // Skip if already initialized
            if ($(e).hasClass('is-initialized')) return;

            let splide = new Splide(e, {
                perPage: 4,
                rewind: true,
                gap: 0,
                arrows: true,
                pagination: true,
                breakpoints: {
                    1200: {
                        perPage: 3
                    },
                    992: {
                        perPage: 2,
                        arrows: false
                    },
                    576: {
                        perPage: 1
                    }
                }
            });

            splide.mount();
        });
    }

    // Initialize on document ready
    $(document).ready(init);

    // Re-initialize on AJAX content load (for flexible content, etc.)
    $(document).on('ajaxComplete', init);

})(jQuery);
